import React, { useState, useEffect } from "react";
import { useStoreon } from "storeon/react";
import { addFavorite, removeFavorite } from "../../core/store/favorite";
import "./favorite-button.scss";
import heart from "../../assets/img/heart.svg";
import heartFilled from "../../assets/img/heart-filled.svg";

const TITLE = "Like";

export const FavoriteButton = ({
  itemId,
  favoriteId,
  onRefreshItems,
  isShowTitle,
}) => {
  const {
    auth: {
      strapiToken,
      profile: { id },
    },
  } = useStoreon("auth");
  const [currentFavoriteId, setCurrentFavoriteId] = useState(favoriteId);
  const getIcon = () => (currentFavoriteId ? heartFilled : heart);

  useEffect(() => {
    setCurrentFavoriteId(favoriteId);
  }, [itemId]);

  const handleClickFavorite = async () => {
    const { data } = currentFavoriteId
      ? await removeFavorite({ strapiToken, favoriteId: currentFavoriteId })
      : await addFavorite({
          strapiToken,
          favorite: { article_id: itemId, user_id: id },
        });

    const favoriteNewValue = currentFavoriteId ? null : data.id;
    setCurrentFavoriteId(favoriteNewValue);

    onRefreshItems(itemId, favoriteNewValue);
  };

  return (
    <>
      {id && (
        <button className={`share-button-icon`} onClick={handleClickFavorite}>
          {/* ICON */}
          <img
            className="share-button-icon_icon"
            src={getIcon()}
            alt="Share this item"
            title={TITLE}
          />
          <p className={isShowTitle ? "has-title" : ""}>{TITLE}</p>
        </button>
      )}
    </>
  );
};
